import { ApiStatuses } from '../../../../global/models/api-model';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { Person } from '../../../../global/models/person-model';

export enum DependentsActionTypes {
    SET_CHILDREN = 'SET_CHILDREN',
    SET_DEPENDENT_PERSON = 'SET_DEPENDENT_PERSON',
    ADD_LOADING_DEPENDENT_PERSON = 'ADD_LOADING_DEPENDENT_PERSON',

    PATCH_DEPENDENT_STATUS = 'PATCH_DEPENDENT_STATUS',
    POST_DEPENDENT_STATUS = 'POST_DEPENDENT_STATUS',
    UPDATE_DEPENDENT = 'UPDATE_DEPENDENT',
    UPDATE_DEPENDENT_PERSON = 'UPDATE_DEPENDENT_PERSON',

    SET_DOMESTIC_PARTNERS = 'SET_DOMESTIC_PARTNERS',

    UNLOAD_DEPENDENT_STATE = 'UNLOAD_DEPENDENT_STATE',

    REMOVE_CHILD = 'REMOVE_CHILD',
}

export interface Dependent {
    _guid: string;
    client_nbr: string;
    masked_client_nbr: string;
    relationship_type: string;
    start_date: string;
    end_date: string;
    first_name: string;
    last_name: string;
    person: Person;
    person_guid: string;
    preliminary_date_of_death?: string;
    date_of_death?: string;
    jurisdiction?: string;
}

export interface Dependents {
    children: Dependent[];
    domesticPartners: Dependent[];
}

export interface DependentsState {
    dependents: Dependents;
    childrenFetched: boolean,
    domesticPartnersFetched: boolean,
    loadingDependentPersons: number,
    postDependentStatus: ApiStatuses,
    patchDependentStatus: ApiStatuses,
}

export interface DependentsAppState {
    [DemographicAppKeys.myCPG]: DependentsState;
    [DemographicAppKeys.arc]: DependentsState;
}

export enum DependentTypes {
    child = 'Child',
    domesticPartner = 'Domestic Partner',
}

export enum ChildTypes {
    step = 'step',
    legal = 'legal',
    adopted = 'adopted_child',
}